window.CartDrawer = window.CartDrawer || {
  init() {
    this.bindGlobalListeners();
    this.bindCartListeners();
  },

  open() {
    document.querySelector(".cart-drawer")?.classList.add("cart-drawer--active");
  },

  close() {
    document.querySelector(".cart-drawer")?.classList.remove("cart-drawer--active");
  },

  updateCartItemCounts(count) {
    document.querySelectorAll(".cart-count").forEach((el) => {
      el.textContent = count;
    });
  },

  async updateCartDrawer() {
    const res = await fetch("/?section_id=cart-drawer");
    const text = await res.text();

    const html = document.createElement("div");
    html.innerHTML = text;

    const newBox = html.querySelector(".cart-drawer").innerHTML;

    document.querySelector(".cart-drawer").innerHTML = newBox;

    // 🔥 IMPORTANT: rebind AFTER DOM replacement
    this.bindCartListeners();
  },

  changeQuantity: async function (key, quantity) {
    const res = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates: { [key]: quantity },
      }),
    });

    const cart = await res.json();

    this.updateCartItemCounts(cart.item_count);
    await this.updateCartDrawer();
  },

  // =========================
  // CART-SPECIFIC LISTENERS
  // (REBOUND EVERY RENDER)
  // =========================
  bindCartListeners() {
    // CLOSE BUTTON (FIXED)
    document.querySelectorAll(".closeButton").forEach((el) => {
      el.addEventListener("click", () => {
        this.close();
      });
    });

    // QUANTITY BUTTONS
    document.querySelectorAll(".cart-drawer-quantity-selector button").forEach((button) => {
      button.addEventListener("click", async () => {
        const key = button.getAttribute("data-line-item-key");

        const input = button.parentElement.querySelector("input");
        const currentQuantity = Number(input.value);

        const isUp = button.classList.contains("cart-drawer-quantity-selector-plus");

        const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;

        await this.changeQuantity(key, newQuantity);
      });
    });

    // REMOVE ITEM
    document.querySelectorAll(".removeItem").forEach((button) => {
      button.addEventListener("click", async () => {
        const key = button.getAttribute("data-line-item-key");

        await this.changeQuantity(key, 0);
      });
    });

    // STOP CART BOX CLICK PROPAGATION
    document.querySelector(".cart-drawer-box")?.addEventListener("click", (e) => {
      e.stopPropagation();
    });
  },

  // =========================
  // GLOBAL LISTENERS (ONCE)
  // =========================
  bindGlobalListeners() {
    // ADD TO CART
    document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
      form.addEventListener("submit", async (e) => {
        e.preventDefault();

        this.open();

        await fetch("/cart/add", {
          method: "POST",
          body: new FormData(form),
        });

        const res = await fetch("/cart.js");
        const cart = await res.json();

        this.updateCartItemCounts(cart.item_count);
        await this.updateCartDrawer();

        const productId = form.getAttribute("data-product-id");
        const productTitle = form.getAttribute("data-product-title");
        const productPrice = form.getAttribute("data-product-price");
        const contentType = form.getAttribute("data-content-type");

        if (productId !== "10299976057165" && typeof window.fbq === "function") {
          window.fbq("trackSingle", "1389826988307183", "AddToCart", {
            currency: "EUR",
            value: Number(productPrice),
            content_ids: [productId],
            content_type: contentType,
            content_name: productTitle,
            number_of_items: 1,
          });

          window.fbq("trackSingle", "565756356291762", "AddToCart", {
            currency: "EUR",
            value: Number(productPrice),
            content_ids: [productId],
            content_type: contentType,
            content_name: productTitle,
            number_of_items: 1,
          });
        }
      });
    });

    // OPEN FROM CART LINK
    document.querySelectorAll('a[href="/cart"]').forEach((a) => {
      a.addEventListener("click", (e) => {
        e.preventDefault();
        this.open();
      });
    });

    // OVERLAY CLOSE
    document.querySelector(".cart-drawer")?.addEventListener("click", () => {
      this.close();
    });

    // CHECKOUT TRACKING
    document.querySelector(".cart-drawer .checkoutButton")?.addEventListener("click", () => {
      if (typeof window.fbq === "function") {
        window.fbq("trackSingle", "1389826988307183", "InitiateCheckout");
        window.fbq("trackSingle", "565756356291762", "InitiateCheckout");
      }
    });
  },
};

// INIT
window.CartDrawer.init();
